var _title, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgRetailer = function SvgRetailer(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 18 17",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "retailer")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4.4.1-Wallet-Top-Up",
    transform: "translate(-35.000000, -662.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "retailer",
    transform: "translate(32.000000, 658.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(4.000000, 5.000000)",
    stroke: "#000000de",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.28077641,4.8 L14.7192236,4.8 C15.2715083,4.8 15.7192236,5.24771525 15.7192236,5.8 C15.7192236,5.88176181 15.7091962,5.96321502 15.6893661,6.04253563 L13.8840491,13.2638034 C13.7171115,13.9315539 13.1171369,14.4 12.4288354,14.4 L3.57116461,14.4 C2.88286315,14.4 2.28288848,13.9315539 2.11595086,13.2638034 L0.310633906,6.04253563 C0.176685179,5.50674072 0.502445873,4.96380623 1.03824078,4.8298575 C1.11756139,4.81002735 1.1990146,4.8 1.28077641,4.8 Z",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.2,
    y1: 7.54285714,
    x2: 5.2,
    y2: 11.6571429,
    id: "Line",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.4,
    y1: 7.54285714,
    x2: 8.4,
    y2: 11.6571429,
    id: "Line-Copy",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.6,
    y1: 7.54285714,
    x2: 11.6,
    y2: 11.6571429,
    id: "Line-Copy-2",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.4,
    y1: -1.81854531e-13,
    x2: 3.2,
    y2: 4.8,
    id: "Line-Copy-3",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.6,
    y1: -1.81854531e-13,
    x2: 10.4,
    y2: 4.8,
    id: "Line-Copy-4",
    strokeLinecap: "round",
    transform: "translate(12.000000, 2.400000) scale(-1, 1) translate(-12.000000, -2.400000) "
  })))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRetailer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/retailer.5b9ece88.svg";
export { ForwardRef as ReactComponent };